module.exports = __webpack_public_path__ + "img/edu_img1.a7427804.png";